module.exports = __webpack_public_path__ + "img/success@2x.1f248ea2.png";